import styled from 'styled-components'

export const AccordionContentContainer = styled.div`
  a {
    color: var(--primary500);
    text-decoration: none;
    font-weight: bold;
  }
`
